export type UploadMediaCompleteEvent = CustomEvent<{
  media_type: string;
  path: string;
}>;

export enum UploadBuckets {
  Dashboard = `dashboard-media`,
  Lexicon = `lexicon-media`,
}

export enum UploadMediaTheme {
  Primary = `primary`,
  Minimal = `minimal`,
}
